import {Data} from './data';
import { FluxStock } from './fluxstock';
import { Produit } from './produit';
import { Facture } from './facture';
import { plainToClass } from 'class-transformer';

export class Bordereau extends Data {

    date_livraison: string;
    type_bordereau: string;
    fluxstock: FluxStock[];
    refgene: string;
    note: string;
    valider: boolean;
    facture: Facture;
    reffac: string;
    datefac: string;
    typefac: string;
    idfac: string;
    livraison_facture: boolean;


    constructor() {
        super(); // on appelle le constructeur du parent;
        this.valider = false;
        this.type_bordereau = 'entree';
    }

    get formatType(): string {

        if (this.type_bordereau === 'entree')
        return 'd\'Entrée';
        else
        return 'de Sortie';


    }

    get formatDateLivraison(): string {

      if (this.date_livraison !== null)
      return  this.formatDate(this.date_livraison);
      else
      return '';

    }

    get op(): string {

        let op = '';

        if (this.typefac === 'vente') {
            if (this.type_bordereau === 'sortie')
            op = 'Livraison';

            if (this.type_bordereau === 'entree')
            op = 'Retour';
        }

        if (this.typefac === 'achat') {
            if (this.type_bordereau === 'sortie')
            op = 'Retour';

            if (this.type_bordereau === 'entree')
            op = 'Achat';
        }

        return op;
    }

    get motif(): string {

        const op = this.op;


        if (this.reffac !== undefined && this.reffac !== null)
        return op + ' Facture ' + this.reffac + ' Du ' + this.formatDate(this.datefac);
        else
        return this.note;

    }

    get formatFacture(): string {

        if (this.reffac !== undefined && this.reffac !== null)
        return this.op + ' Facture ' + this.reffac + ' Du ' + this.formatDate(this.datefac);
        else
        return this.note;
    }


    get montantFluxstock(): number {

        let total = 0;

        const classfluxstock = plainToClass(FluxStock, this.fluxstock);

        for ( let i = 0; i < classfluxstock.length; i++) {

            total += classfluxstock[i].prixTotal;

        }

        return total;

    }



    // uitliseé lors de l'enregistrement des livraison pour éviter d'avoir plusieurs enregistrement d'un même produit en tenant compte des livraisons déjà enregsitré ( date antérieur)
    cmdLivreByProd( idproduit: number ): FluxStock {

        let total: FluxStock;

        if ( this.fluxstock !== null && this.fluxstock !== undefined) {

            for ( let i = 0; i < this.fluxstock.length; i++) {

                if (this.fluxstock[i].produit.id === idproduit && this.fluxstock[i].date_flux === undefined)
                total = this.fluxstock[i];

            }

        }

        return total;

    }

    // uitliseé lors de suppression des livraison pour recuperer l'index des enregsitrement qui n'ont pas encore d'id ( donc non sauvegardés)
    indexCmdLivreByProd( idproduit: number ): number {

        let total: number;

        if ( this.fluxstock !== null && this.fluxstock !== undefined) {


            for ( let i = 0; i < this.fluxstock.length; i++) {

                if (this.fluxstock[i].produit.id === idproduit && this.fluxstock[i].date_flux === undefined)
                total = i;

            }


        }

        return total;

    }



    get quantiteLivrer(): number {

        let total = 0;

        if ( this.fluxstock !== null && this.fluxstock !== undefined) {

            const classfluxstock = plainToClass(FluxStock, this.fluxstock);

            for ( let i = 0; i < classfluxstock.length; i++) {

                total += classfluxstock[i].quantite;

            }


        }

        return total;

    }

    qteLivrerByProd( idproduit: number ): number {

        let total = 0;

        if ( this.fluxstock !== null && this.fluxstock !== undefined) {

            const classfluxstock = plainToClass(FluxStock, this.fluxstock);

            for ( let i = 0; i < classfluxstock.length; i++) {

                if (classfluxstock[i].produit.id === idproduit)
                total += classfluxstock[i].quantite;

            }


        }

        return total;

    }


    get montantHTFluxstock(): number {

        let total = 0;

        if (this.fluxstock !== undefined) {

            const classfluxstock = plainToClass(FluxStock, this.fluxstock);

            for ( let i = 0; i < classfluxstock.length; i++) {

                total += classfluxstock[i].prixHT;

            }

        }

        return total;

    }

    get montantHTLivrer(): number {

        let total = 0;

        if (this.fluxstock !== undefined) {

            const classfluxstock = plainToClass(FluxStock, this.fluxstock);

            for ( let i = 0; i < classfluxstock.length; i++) {

                total += classfluxstock[i].prixHT;

            }

        }

        return total;

    }


    get montantTTCFluxstock(): number {

        let total = 0;

        if (this.fluxstock !== undefined) {

            const classfluxstock = plainToClass(FluxStock, this.fluxstock);

            for ( let i = 0; i < classfluxstock.length; i++) {

                total += classfluxstock[i].prixTotal;

            }

        }

        return total;

    }




    get etatBordereau(): string {

        status = '<span class="red"> Non inventorié </span>';

        if (this.valider !== undefined && this.valider !== null) {

            if (this.valider)
            status = '<span class="green"> Inventorié </span>';
        }

        return status;

    }


}
